import TableauDeBordPage from "../pages/dashboard/TableauDeBordPage";
import FilActualitePage from "../pages/FilActualitePage";
import GroupeListPage from "../pages/groupe/GroupeListPage";
import GroupeDetailsPage from "../pages/groupe/GroupeDetailsPage";
import UserListPage from "../pages/user/UserListPage";
import UserDetailsPage from "../pages/user/UserDetailsPage";
import UserProfilePage from "../pages/user/UserProfilePage";
import NotificationListPage from "../pages/notification/NotificationListPage";
import AuthenticationPage from "../pages/auth/AuthenticationPage";
import LoginPage from "../pages/auth/LoginPage";
import ErrorPage from "../pages/auth/ErrorPage";
import ModeleListPage from "../pages/modele/ModeleListPage";
import ModeleDetailsPage from "../pages/modele/ModeleDetailsPage";
import AffaireListPage from "../pages/affaire/AffaireListPage";
import AffaireDetailsPage from "../pages/affaire/AffaireDetailsPage";
import TacheListPage from "../pages/tache/TacheListPage";
import TacheDetailsPage from "../pages/tache/TacheDetailsPage";
import ActiviteListPage from "../pages/activite/ActiviteListPage";
import MesActivitesListPage from "../pages/activite/MesActivitesListPage";
import EtapeListPage from "../pages/etape/EtapeListPage";
import StatutListPage from "../pages/statut/StatutListPage";
import PrioriteListPage from "../pages/priorite/PrioriteListPage";
import ParametragePage from "../pages/ParametragePage";
import MonnaieListPage from "../pages/monnaie/MonnaieListPage";
import DepartementListPage from "../pages/departement/DepartementListPage";
import DepartementDetailsPage from "../pages/departement/DepartementDetailsPage";
import PersonnelListPage from "../pages/personnel/PersonnelListPage";
import PersonnelDetailsPage from "../pages/personnel/PersonnelDetailsPage";
import MonEquipePage from "../pages/personnel/MonEquipePage";
import DeploymentListPage from "../pages/deployment/DeploymentListPage";

export const routes = [
    {
        path: '/',
        component: TableauDeBordPage,
        exact: true,
        permission: 'VIEW-DASHBOARD'
    },
    {
        path: '/fil-actualite',
        component: FilActualitePage,
        exact: true,
        permission: 'VIEW-DASHBOARD'
    },
    {
        path: '/groupe',
        component: GroupeListPage,
        exact: true,
        permission: 'VIEW-GROUPS'
    },
    {
        path: '/groupe/:uid',
        component: GroupeDetailsPage,
        exact: true,
        permission: 'VIEW-GROUP'
    },
    {
        path: '/user',
        component: UserListPage,
        exact: true,
        permission: 'VIEW-USERS'
    },
    {
        path: '/user/:uid',
        component: UserDetailsPage,
        exact: true,
        permission: 'VIEW-USER'
    },
    {
        path: '/profile',
        component: UserProfilePage,
        exact: true,
        permission: ''
    },
    {
        path: '/notifications',
        component: NotificationListPage,
        exact: true,
        permission: ''
    },
    {
        path: '/authentificate/:token',
        component: AuthenticationPage,
        exact: true,
        permission: ''
    },
    {
        path: '/login',
        component: LoginPage,
        exact: true,
        permission: ''
    },
    {
        path: '/error',
        component: ErrorPage,
        exact: true,
        permission: ''
    },
    {
        "path": "/modele",
        "component": ModeleListPage,
        "exact": true,
        "permission": "VIEW-SETTINGS"
    },
    {
        "path": "/modele/:uid",
        "component": ModeleDetailsPage,
        "exact": true,
        "permission": "VIEW-SETTINGS"
    },
    {
        "path": "/affaire",
        "component": AffaireListPage,
        "exact": true,
        "permission": "VIEW-AFFAIRES"
    },
    {
        "path": "/affaire/:uid",
        "component": AffaireDetailsPage,
        "exact": true,
        "permission": "VIEW-AFFAIRE"
    },
    {
        "path": "/tache",
        "component": TacheListPage,
        "exact": true,
        "permission": "VIEW-TACHES"
    },
    {
        "path": "/tache/:uid",
        "component": TacheDetailsPage,
        "exact": true,
        "permission": "VIEW-TACHE"
    },
    {
        "path": "/activite",
        "component": ActiviteListPage,
        "exact": true,
        "permission": ''
    },
    {
        path: "/mes-activites",
        component: MesActivitesListPage,
        exact: true,
        permission: ''
    },
    {
        path: "/mon-equipe",
        component: MonEquipePage,
        exact: true,
        permission: ''
    },
    {
        "path": "/etape",
        "component": EtapeListPage,
        "exact": true,
        "permission": "VIEW-SETTINGS"
    },
    {
        "path": "/priorite",
        "component": PrioriteListPage,
        "exact": true,
        "permission": "VIEW-SETTINGS"
    },
    {
        "path": "/statut",
        "component": StatutListPage,
        "exact": true,
        "permission": "VIEW-SETTINGS"
    },
    {
        path: '/settings',
        component: ParametragePage,
        exact: true,
        permission: 'VIEW-SETTINGS'
    },
    {
        path: '/deploiement',
        component: DeploymentListPage,
        exact: true,
        permission: ''
    },
    {
        "path": "/monnaie",
        "component": MonnaieListPage,
        "exact": true,
        "permission": "VIEW-SETTINGS"
    }, {
        "path": "/departement",
        "component": DepartementListPage,
        "exact": true,
        "permission": "VIEW-DEPARTEMENTS"
    },
    {
        "path": "/departement/:uid",
        "component": DepartementDetailsPage,
        "exact": true,
        "permission": "VIEW-DEPARTEMENT"
    }, {
        "path": "/personnel",
        "component": PersonnelListPage,
        "exact": true,
        "permission": "VIEW-PERSONNELS"
    },
    {
        "path": "/personnel/:uid",
        "component": PersonnelDetailsPage,
        "exact": true,
        "permission": "VIEW-PERSONNEL"
    },
    {
        path: '*',
        component: TableauDeBordPage,
        exact: true,
        permission: 'VIEW-DASHBOARD'
    },
];